import { memo as Memo } from 'react'

//* Components
import Text from 'components/common/Text'
import Icon from 'components/common/Icon'
import Image from 'components/common/Image'
import CustomLink from 'components/common/CustomLink'

//* Style
import EventItemStyle from './style'

//* Helper
import { config } from 'helpers'

const EventItem = Memo(({ className, categories, date, featured_image, location, slug, title }) => {
    return (
        <EventItemStyle className={`event-item ${className || ''}`}>
            <CustomLink
                className={`event-link`}
                url={`${config.routes.events.path}/${slug}`}
            >
                <div className={`event-inner-item`}>
                    <div className={`left-wrapper`}>
                        <div className={`top-cont`}>
                            <div className={`top-inner-cont`}>
                                {categories && categories.length > 0 ? (
                                    <div className='event-categories'>
                                        <Text
                                            tag='p'
                                            className='event-cat p-2 font-montserrat textBlack-100'
                                        >
                                            {categories[0].name}
                                        </Text>

                                        {categories.length - 1 > 0 ? (
                                            <Text
                                                tag='p'
                                                className='event-cat p-2 font-montserrat textBlack-100'
                                            >
                                                +{categories.length - 1}
                                            </Text>
                                        ) : null}
                                    </div>
                                ) : null}

                                <div className={`location-wrapper`}>
                                    <Text
                                        tag='span'
                                        className='p-2 font-montserrat textBlack-100 capitalize location'
                                    >
                                        {location}
                                    </Text>

                                    <Icon
                                        name={`place`}
                                        className={`h6 place-icon`}
                                    >
                                        <span className={`path1`} />
                                        <span className={`path2`} />
                                        <span className={`path3`} />
                                        <span className={`path4`} />
                                        <span className={`path5`} />
                                        <span className={`path6`} />
                                        <span className={`path7`} />
                                        <span className={`path8`} />
                                        <span className={`path9`} />
                                        <span className={`path10`} />
                                        <span className={`path11`} />
                                        <span className={`path12`} />
                                        <span className={`path13`} />
                                    </Icon>
                                </div>
                            </div>

                            <Text
                                tag='h5'
                                className='title h5 font-montserrat textBlack-100'
                            >
                                {title}
                            </Text>
                        </div>

                        <Text
                            tag='span'
                            className='date h6 font-montserrat textBlack-100'
                        >
                            {date}
                        </Text>
                    </div>

                    <div className={`right-wrapper`}>
                        <Image
                            src={featured_image?.src}
                            alt={featured_image?.alt}
                        />
                    </div>
                </div>
            </CustomLink>
        </EventItemStyle>
    )
})

export default EventItem
